import React from 'react';
import styled from 'styled-components';
import { height, maxHeight, maxWidth, space, width } from 'styled-system';
import { Classes, NonIdealState } from '@blueprintjs/core';
import flex from './utils/flex';

import Text from './Text';

const WrappedEmptyState = styled(NonIdealState)`
  ${width};
  ${space};
  ${maxWidth};
  ${height};
  ${maxHeight};
  ${flex};

  /* remove max-width restraint */
  &.${Classes.NON_IDEAL_STATE} > * {
    max-width: none;
  }

  &.${Classes.NON_IDEAL_STATE} .bp4-icon svg path {
    stroke: inherit;
    stroke-opacity: 100%;
  }
`;

function EmptyState({ description = '', ...rest }) {
  return (
    <WrappedEmptyState
      {...rest}
      description={
        <Text muted textAlign="left" data-testid="emptyStateIndicator">
          {description}
        </Text>
      }
    />
  );
}

export default EmptyState;
